import { Box, Card, Typography } from "@mui/material";
import { numberFormatWithK } from "../../../utils/nunberFormat";

interface Props {
    title: string,
    amount: number,
    icon: any
}

const CardSaleReport = ({ title, amount, icon }: Props) => {
    return <Card sx={{ boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)', p: 4, borderRadius: '16px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box>
                <Typography sx={{ color: '#212B36', mb: 2 }}>{title}</Typography>
                <Typography fontSize={32} fontWeight="bold">{numberFormatWithK(amount)}</Typography>
            </Box>
            <Box>
                <img src={icon} alt="" style={{
                    width: 52,
                    height: 35
                }} />
            </Box>
        </Box>

    </Card>
}
export default CardSaleReport;